// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderHeader":"InvoiceMembers_PlaceholderHeader__2guPc","PlaceholderContent":"InvoiceMembers_PlaceholderContent__1bfsU"};